// extracted by mini-css-extract-plugin
export default {"primary-btn":"PrimaryButton_primary-btn__gLa+E","primary-btn__icon":"PrimaryButton_primary-btn__icon__AsE5c","primary-btn__text":"PrimaryButton_primary-btn__text__BmCzJ"};